<template>
  <div class="list-item">
    <div class="item-content">
      {{song.name}} - <span class="artist">{{song.artists[0].name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'song-item',
  props: ['song'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style type="scss" scoped>
  @import url('https://fonts.googleapis.com/css?family=Montserrat|Rammetto+One');
  .list-item {
    border-left: solid 5px #82BF56;
    background-color: #1b1b1b;
  }

  .item-content {
    margin-top: 4px;
    padding-left: 10px;
    font-size: 20px;
    color: aliceblue;
  }

  .artist {
    font-size: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/components/SongItem.vue